import React from 'react'
import { Row, Col } from 'react-bootstrap'
import BarreraBruto from '../bruto/BarreraBruto'
import { Button, FormControlLabel, Switch } from '@material-ui/core'

function BarrerasDeBruto (props) {
  const { forzarBarreras, modoBarreras, rolAutorizado } = props

  const abrirBarreraEntrada = () => {
    props.abrirBarreraEntradaBruto()
  }

  const cerrarBarreraEntrada = () => {
    props.cerrarBarreraEntradaBruto()
  }

  const cerrarBarreraSalida = () => {
    props.cerrarBarreraSalidaBruto()
  }

  return (
    <>
      <div className='container-acciones-config'>
        <Button
          onClick={abrirBarreraEntrada}
          className='btn-accion-pesado-config'
          variant='contained'
          color='primary'
          style={{ margin: '8px' }}
        >
            Abrir barrera entrada
        </Button>
        <Button
          onClick={cerrarBarreraEntrada}
          className='btn-accion-pesado-config'
          variant='contained'
          color='primary'
          style={{ margin: '8px' }}
        >
            Cerrar barrera entrada
        </Button>
        <div className='btn-accion-pesado-config'>
          <BarreraBruto
            style={{ margin: '8px' }}
            setMotivo={props.setMotivoActividadBarrera}
            dialogOpen={props.dialogOpen}
          />
        </div>

        <Button
          onClick={cerrarBarreraSalida}
          className='btn-accion-pesado-config'
          variant='contained'
          color='primary'
          style={{ margin: '8px' }}
        >
            Cerrar barrera salida
        </Button>
      </div>

      <Row style={{ margin: '2% auto' }}>
        <Col md={6}>
          <FormControlLabel
            control={
              <Switch
                color='primary'
                name='cicloBarreras'
                onChange={props.updateCiclo}
                checked={modoBarreras === 'auto'}
              />
            }
            label='Ciclo automático'
          />
        </Col>
        <Col md={6}>
          <FormControlLabel
            control={
              <Switch
                color='primary'
                name='forzarBarreras'
                onChange={props.updateForzado}
                checked={forzarBarreras === 'si'}
                disabled={!rolAutorizado}
              />
            }
            label='Forzar barreras abiertas'
          />
        </Col>
      </Row>

    </>
  )
}

export default BarrerasDeBruto
